import React, { useEffect, Fragment } from 'react'
import { Input } from 'antd'

const { TextArea } = Input

const UploadDesign = ({ handleChangeFileUpload, note, handleChangeNote, fileUpload, linkDesign, description, handleChangeDescription }) => {

    useEffect(() => {
        return () => {
            fileUpload && URL.revokeObjectURL(fileUpload.preview)
        }
    }, [fileUpload])

    const handleUploadFile = e => {
        const file = e.target.files[0]
        file.preview = URL.createObjectURL(file)
        handleChangeFileUpload(file)
    }

    return (
        <Fragment>
            <div className='UploadDesign'>
                <div className="FileDesign mb-3">
                    <label>Upload design</label>
                    <div className="UploadName d-flex justify-content-between">
                        <input
                            type="file"
                            onChange={handleUploadFile}
                            id="uploadFileDesign"
                            className='d-none'
                            accept=".png, .jpg"
                        />
                        <span className='mr-auto d-block' style={{ maxWidth: "88%" }}>
                            {(fileUpload && fileUpload.name) || "Tên file design"}
                        </span>
                        <label htmlFor="uploadFileDesign">
                            <div className="UploadLayout">
                                <span className="btn bg-secondary">Choose file</span>
                            </div>

                        </label>
                    </div>
                </div>
                <div className="ImageDesign mb-3">
                    {
                        !fileUpload && !linkDesign && <b className=''>Hình ảnh design (nếu có)</b>
                    }
                    {
                        fileUpload && "default" !== fileUpload &&
                        <img src={fileUpload.preview} alt="Preview" />
                    }
                    {
                        linkDesign && !fileUpload.name && "default" !== fileUpload &&
                        <img src={linkDesign} alt="Preview" />
                    }
                </div>
                {
                    !!linkDesign && !fileUpload.name && (
                        <div className="LinkDesign d-flex flex-column mb-3">
                            <span>Link design</span>
                            <input type="text" value={linkDesign} className="w-50 border pe-none" />
                        </div>
                    )
                }
                <div className="col-12 mb-3 p-0 d-flex flex-column">
                    <label>Description</label>
                    <Input
                        style={{ width: '50%' }}
                        onChange={(e) => handleChangeDescription(e.target.value)}
                        allowClear
                        type="input"
                        value={description}
                    />
                </div>
                <div className="InputNote d-flex flex-column">
                    <label>Note</label>
                    <TextArea
                        value={note}
                        onChange={(e) => handleChangeNote(e.target.value)}
                        style={{ width: '50%' }}
                        autoSize={{
                            minRows: 3,
                            maxRows: 5,
                        }}
                    />
                </div>
            </div>
        </Fragment>
    )
}

export default UploadDesign